const basicjobDetail = {
  'Min expected no. of Application': '3',
  'No. of Job per Location': '1',
  'Company Logo Display': true
}

const standardjobDetail = {
  'Min expected no. of Application': '15',
  'No. of Job per Location': '2',
  'Company Logo Display': true
}

const premiumjobDetail = {
  'Min expected no. of Application': '25',
  'No. of Job per Location': '5',
  'Company Logo Display': true,
  'Highlighted Job notification to most suitable candidates': true,
  'Back office support in applicant verification and screening on clients behalf through telephone': true,
  'Job orientation to selected candidate': true,
  'Suitable application ( as per location, profession, salary expectations and experience)': true
}

export { basicjobDetail, standardjobDetail, premiumjobDetail }
